export const LOYALTY_TYPE_NONE = 'None'
export const LOYALTY_TYPE_NEXT = 'NEXT'
export const LOYALTY_TYPE_NEXT_PREMIUM = 'NEXT Premium'
export const LOYALTY_TYPE_PPFS = 'PPFS'
